import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";
import type { ForNodeType } from "@/components/features/_model/types";

import { CheckboxField } from "@/components/ui/form/fields/check-box-field/check-box";

type Props = {
	onlyUseCreditPayment: ForNodeType<boolean>;
	onSetOnlyUseCreditPayment: (input: boolean) => void;
};

export const QuestionPlanOnlyUseCreditPayment = ({ onSetOnlyUseCreditPayment, onlyUseCreditPayment }: Props) => {
	const label = "事前決済限定プラン";
	const guide =
		"ホテルポリシーで現地決済を許可している場合でも、こちらにチェックを入れたプランは<b>事前決済のみ</b>での販売になります。";

	return (
		<FeatureIslandCategoryQuestionForMain
			required={false}
			title={label}
			guide={guide}
			isEdited={onlyUseCreditPayment.isEdited}
			hasError={Boolean(onlyUseCreditPayment.error)}
			inputChildren={
				<CheckboxField
					value={onlyUseCreditPayment.value}
					label={"事前決済のみ利用可能なプランにする"}
					handleChange={onSetOnlyUseCreditPayment}
					errorMessage={onlyUseCreditPayment.error}
				/>
			}
		/>
	);
};

QuestionPlanOnlyUseCreditPayment.displayName = "QuestionPlanOnlyUseCreditPayment";
